import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';
import type { TagItem } from '@/components/common/FormExpandableSection/FormExpandableSection';

export function getRetargetingTags(retargeting: TargetingBaseType['retargeting']): TagItem[] {
  if (!retargeting.enabled) {
    return [];
  }
  const result: TagItem[] = [];
  const zoneCount = retargeting.zoneIds?.length ?? 0;
  if (zoneCount > 0) {
    result.push({ label: `${zoneCount} zone${zoneCount !== 1 ? 's' : ''}` });
  }
  if (retargeting.sinceDays != null) {
    const daysLabel =
      retargeting.sinceDays === 1
        ? 'Last 1 day'
        : retargeting.sinceDays === 7
          ? 'Last 7 days'
          : retargeting.sinceDays === 30
            ? 'Last 30 days'
            : `Last ${retargeting.sinceDays} days`;
    result.push({ label: daysLabel });
  }

  return result;
}
